import React from 'react'
import { PropTypes } from 'prop-types'

class ContractorRow extends React.Component {
  constructor(props) {
    super(props)
    this.handleRowClick = this.handleRowClick.bind(this)
  }

  handleRowClick(e) {
    e.preventDefault()
    this.props.onSelect(this.props.contractor)
  }

  render() {
    return (
      <tr className="ln-c-table__row">
        <td className="ln-c-table__cell">
          {(new Date() - new Date(this.props.contractor.addedAt)) < (120 * 120 * 1000) ?
            <div
              className="c-badge c-badge--secondary c-badge--inverted"
              style={({ border: '1px solid', marginRight: this.props.contractor.active ? '20px' : '10px' })}
            >New</div> : ''}
          {!this.props.contractor.active ?
            <div
              className="c-badge c-badge--secondary c-badge--inverted o-generic--inactive-badge-alignment"
            >Inactive</div> : ''}
          { this.props.isReadOnly === true &&
            this.props.contractor.fullName
          }
          { this.props.isReadOnly !== true &&
            <a
              href={`/employers/${this.props.employerId}/contractors/${this.props.contractor.id}`}
              onClick={this.handleRowClick}
            >{this.props.contractor.fullName}</a>
          }
        </td>
        <td className="ln-c-table__cell">{this.props.contractor.jobRole}</td>
        <td className="ln-c-table__cell">{this.props.contractor.telephoneNumber || '-'}</td>
        <td className="ln-c-table__cell">{this.props.contractor.carRegistration || '-'}</td>
        <td className="ln-c-table__cell">{this.props.contractor.uniqueId || '-'}</td>
        <td className="ln-c-table__cell">{this.props.contractor.lastRegistrationDate || '-'}</td>
      </tr>
    )
  }
}

ContractorRow.propTypes = {
  employerId: PropTypes.number.isRequired,
  contractor: PropTypes.shape({
    id: PropTypes.number.isRequired,
    fullName: PropTypes.string.isRequired,
    jobRole: PropTypes.string.isRequired,
    telephoneNumber: PropTypes.string,
    carRegistration: PropTypes.string,
    uniqueId: PropTypes.string,
    active: PropTypes.bool.isRequired,
    addedAt: PropTypes.string,
    lastRegistrationDate: PropTypes.string
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool.isRequired
}

export default ContractorRow



// WEBPACK FOOTER //
// ./src/components/ContractorGrid/ContractorRow/index.jsx